import React ,{ useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { IAppPropsWithRoute } from '../../../common/types';

import {
    Box, Grid,
    Button, IconButton,
    TextField, Select, MenuItem,
    FormHelperText, FormControl, FormControlLabel,
    RadioGroup, Radio, Checkbox
} from '@material-ui/core';
import { useStyles } from "../styles";
import * as Icons from "../iconComponents";
import { useFormContext, Controller } from "react-hook-form";
import IndexedDb from '../IndexedDb';

interface PcrWidgetProps extends IAppPropsWithRoute {

};

const SubFormWidget: React.FC<PcrWidgetProps> = () => {
    const classes = useStyles();
    const history = useHistory();
    
    const { handleSubmit, watch, errors, control, formState, setValue, getValues, setError } = useFormContext();
    const pcrType = watch("pcr_type");
    
    const[Indexdb,setIndexdb]=useState("");
    const [OtherInterventions, setOtherInterventions] = useState(""); 
    React.useEffect(() => {
        let db:any = null;
        db = localStorage.getItem("PatientDB");
        setIndexdb(db);
        getindexdbvalues();
    }, [])
    const getindexdbvalues = async (): Promise<void> => {
        let db:any = null;
        db = localStorage.getItem("PatientDB");
        if(db!=null && db !="")
        {
        const indexedDb = new IndexedDb(db);
        await indexedDb.createObjectStore(indexedDb.patientcarerecord);
        let val = await indexedDb.getAllValue('ActionIntervention');
        for(let i=0;i<val.length;i++)
        {
            if(val[i].Key == "OtherInterventions")
            {
                setOtherInterventions(val[i].value.column);
                return;
            }
        }
        }
    }
    const handleindexdbsave = async (Key:any,value:any): Promise<void> => {    
        if(Indexdb!=null || Indexdb !="")
        {
        
        const indexedDb = new IndexedDb(Indexdb);      
        await indexedDb.createObjectStore(indexedDb.patientcarerecord);
        await indexedDb.putValue('ActionIntervention', { column:value,Patid:0 },Key);
        }
    }
    return (
        <div>
            <div className={classes.pcrAddTabHeading}>
                <div>
                    Actions & Interventions
                </div>
            </div>
            <Grid container className={classes.formContainer} spacing={3}>
                
                <Grid item xs={12} sm={12}>
                    <div className={classes.formControlLabel}>
                        OTHER INTERVENTIONS / RECOMMENDATIONS
                        {pcrType === "3" && (<>
                        <span className={"incident"}>
                            <Icons.IncidentIcon /> INCIDENT
                        </span>
                        </>)}
                    </div>
                    <Controller
                        control={control}
                        name="other_interventions"
                        defaultValue={OtherInterventions}
                        render={props => (
                            <TextField
                                name={props.name}
                                defaultValue={OtherInterventions}
                                variant='outlined'
                                InputProps={{ classes: { root: classes.multilinetextFieldInput } }}
                                inputProps={{ maxLength: 500, minLength: 0,autocomplete:'disabled' }}
                                error={errors.other_interventions} helperText={errors.other_interventions ? errors.other_interventions.message : ""}
                                placeholder=""
                                multiline={true}
                                rows={6}
                                onBlur={(e) => {
                                    handleindexdbsave('OtherInterventions',e.target.value);
                                }}
                            />
                        )}
                    />
                </Grid>

            </Grid>
        </div>
    );
}

export default React.memo(withRouter(SubFormWidget));